export const MODULE_LIST = [
  {
    name: 'dashboard',
    title: 'Home',
    icon: 'menu_home',
    module: 'DASHBOARD',
  },
  {
    name: 'user',
    title: 'Users',
    icon: 'menu_users',
    module: 'USERS',
  },
  {
    name: 'membership',
    title: 'Membership',
    icon: 'menu_membership',
    module: 'MEMBERSHIP',
  },
  {
    name: 'event',
    title: 'Event',
    icon: 'menu_events',
    module: 'EVENT',
  },
  {
    name: 'news',
    title: 'News',
    icon: 'menu_news',
    module: 'NEWS',
  },
  {
    name: 'donation',
    title: 'Donation',
    icon: 'menu_donation',
    module: 'DONATION',
  },
  {
    name: 'showcase',
    title: 'Gallery',
    icon: 'menu_gallery',
    module: 'SHOWCASE',
  },
  {
    name: 'message',
    title: 'Message',
    icon: 'menu_message',
    module: 'MESSAGE',
  },
  {
    name: 'reports',
    title: 'Reports',
    icon: 'menu_reports',
    module: 'REPORTS',
  },
  {
    name: 'customization',
    title: 'Settings',
    icon: 'menu_settings',
    children: [
      {
        name: 'user-labels',
        title: 'User Labels',
      },
      {
        name: 'home-page',
        title: 'Home Page',
      },
      {
        name: 'site-details',
        title: 'Site Details',
      },
      {
        name: 'about-us',
        title: 'About Us',
      },
      {
        name: 'integration',
        title: 'Integration',
      },
      {
        name: 'preference',
        title: 'Preference',
      },
    ],
    module: 'CUSTOMIZATION',
  },
  {
    name: 'admins',
    title: 'Admins',
    icon: 'menu_admins',
    module: 'ADMINS',
  },
];
